import type { FC } from "react";

import type { SiteEntity } from "src/app/features/Site/types/SiteEntity";
import { VirtualSiteBatchUpdateForm } from "src/app/features/VirtualSiteGroup/components/forms/VirtualSiteBatchUpdateForm";
import type { VirtualSiteBatchUpdateEntity } from "src/app/features/VirtualSiteGroup/types/VirtualSiteBatchUpdateEntity";
import { BatchUpdateDrawerButton } from "../../../../../components/DrawerForm/BatchUpdateDrawer/BatchUpdateDrawerButton";
import { useBatchUpdateDrawer } from "../../../../../components/DrawerForm/BatchUpdateDrawer/useBatchUpdateDrawer";
import type { ButtonProps } from "../../../../../components/FeatureButtons/types";
import { useVirtualSiteBatchUpdateMutation } from "../../../../../components/Form/formComponents/VirtualSitesView/vsgServerApi";

export const VirtualSiteBatchUpdateButton: FC<ButtonProps<SiteEntity>> = ({ isDisabled, items }) => {
    const [saveFormData] = useVirtualSiteBatchUpdateMutation();
    const { open, form, isDisabledFinal, isSubmitting, showDrawer, onClose, onSubmit } = useBatchUpdateDrawer<
        VirtualSiteBatchUpdateEntity,
        SiteEntity
    >(items, isDisabled, saveFormData);

    return (
        <BatchUpdateDrawerButton
            isDisabled={isDisabledFinal}
            open={open}
            onOpen={showDrawer}
            onClose={onClose}
            isSubmitting={isSubmitting}
            titleKey="virtualSite.batchUpdate.header"
        >
            <VirtualSiteBatchUpdateForm form={form} searchCallback={onSubmit} />
        </BatchUpdateDrawerButton>
    );
};
